import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo } from '@ember-data/model';
import { debug } from '@ember/debug';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22;
let SubscriptionModel = (_dec = attr('boolean'), _dec2 = attr('boolean'), _dec3 = attr('string'), _dec4 = attr('boolean'), _dec5 = attr('boolean'), _dec6 = attr('string'), _dec7 = attr('number'), _dec8 = attr('number'), _dec9 = attr('number'), _dec0 = attr('string'), _dec1 = attr('number'), _dec10 = attr('number'), _dec11 = attr('number'), _dec12 = attr('number'), _dec13 = attr('string'), _dec14 = attr('number'), _dec15 = attr('number'), _dec16 = attr('number'), _dec17 = attr('number'), _dec18 = attr('number'), _dec19 = attr('boolean'), _dec20 = belongsTo('plan', {
  inverse: null,
  async: false
}), _dec21 = belongsTo('organization', {
  inverse: 'subscription',
  async: false
}), _dec22 = attr('boolean', {
  defaultValue: false
}), _class = class SubscriptionModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "trial", _descriptor, this);
    _initializerDefineProperty(this, "active", _descriptor2, this);
    _initializerDefineProperty(this, "trial_expires_on", _descriptor3, this);
    _initializerDefineProperty(this, "month_billing_cycle", _descriptor4, this);
    _initializerDefineProperty(this, "year_billing_cycle", _descriptor5, this);
    _initializerDefineProperty(this, "expire_date", _descriptor6, this);
    _initializerDefineProperty(this, "paied_agents", _descriptor7, this);
    _initializerDefineProperty(this, "booking_online", _descriptor8, this);
    _initializerDefineProperty(this, "utenti_calendario", _descriptor9, this);
    _initializerDefineProperty(this, "promo_code", _descriptor0, this);
    _initializerDefineProperty(this, "fix", _descriptor1, this);
    _initializerDefineProperty(this, "perc", _descriptor10, this);
    _initializerDefineProperty(this, "duration_day", _descriptor11, this);
    _initializerDefineProperty(this, "giorni_rimanenti", _descriptor12, this);
    _initializerDefineProperty(this, "sdi_rimanenti", _descriptor13, this);
    _initializerDefineProperty(this, "sms_rimanenti", _descriptor14, this);
    _initializerDefineProperty(this, "otp_fes_rimanenti", _descriptor15, this);
    _initializerDefineProperty(this, "otp_advanced_rimanenti", _descriptor16, this);
    _initializerDefineProperty(this, "pck_mass_mail", _descriptor17, this);
    _initializerDefineProperty(this, "grafo_licenses", _descriptor18, this);
    _initializerDefineProperty(this, "mail_massive", _descriptor19, this);
    _initializerDefineProperty(this, "plan", _descriptor20, this);
    _initializerDefineProperty(this, "organization", _descriptor21, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor22, this);
  }
  get sdi_rimanenti_json() {
    if (!this.sdi_rimanenti) {
      return null;
    }
    let json = null;
    try {
      json = JSON.parse(this.sdi_rimanenti);
    } catch (e) {
      debug(e);
    }
    return json;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "trial", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "active", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "trial_expires_on", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "month_billing_cycle", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "year_billing_cycle", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "expire_date", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "paied_agents", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "booking_online", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "utenti_calendario", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "promo_code", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "fix", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "perc", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "duration_day", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "giorni_rimanenti", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "sdi_rimanenti", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "sms_rimanenti", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "otp_fes_rimanenti", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "otp_advanced_rimanenti", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "pck_mass_mail", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "grafo_licenses", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "mail_massive", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "plan", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "organization", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { SubscriptionModel as default };
//# sourceMappingURL=subscription.js.map
